export function isDmsMachine(machine?: { name?: string } | null): boolean {
    return Boolean(machine?.name?.includes('DMS'))
}

export function hasDmsInFinishing(machines?: { name?: string }[] | null): boolean {
    return Boolean(machines?.some(isDmsMachine))
}
